async function setCountry() {
  const countryCodeToName = {
    US: "United States",
    BM: "Bermuda",
    GL: "Greenland",
    PM: "Saint Pierre and Miquelon",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    IE: "Ireland",
    FR: "France",
    BE: "Belgium",
    NL: "Netherlands",
    LU: "Luxembourg",
    AT: "Austria",
    MC: "Monaco",
    LI: "Liechtenstein",
    CH: "Switzerland",
    CA: "Canada",
    IN: "India",
    AU: "Australia",
    MX: "Mexico",
    AD: "Andorra",
    DE: "Germany",
    PL: "Poland",
    RO: "Romania",
    HU: "Hungary",
    CZ: "Czech Republic",
    SK: "Slovakia",
    BG: "Bulgaria",
    MD: "Moldova",
    UA: "Ukraine",
    BY: "Belarus",
    RU: "Russia",
    AL: "Albania",
    RS: "Serbia",
    MK: "North Macedonia",
    ME: "Montenegro",
    BA: "Bosnia and Herzegovina",
    XK: "Kosovo",
    SA: "Saudi Arabia",
    QA: "Qatar",
    BH: "Bahrain",
    KW: "Kuwait",
    OM: "Oman",
    JO: "Jordan",
    LB: "Lebanon",
    IL: "Israel",
    PS: "Palestine",
    IQ: "Iraq",
    SY: "Syria",
    YE: "Yemen",
    IR: "Iran",
    PK: "Pakistan",
    BD: "Bangladesh",
    LK: "Sri Lanka",
    NP: "Nepal",
    BT: "Bhutan",
    MV: "Maldives",
    AF: "Afghanistan",
    JP: "Japan",
    KR: "South Korea",
    CN: "China",
    KP: "North Korea",
    TW: "Taiwan",
    MN: "Mongolia",
    HK: "Hong Kong",
    MO: "Macau",
    PH: "Philippines",
    TH: "Thailand",
    SG: "Singapore",
    MY: "Malaysia",
    ID: "Indonesia",
    VN: "Vietnam",
    KH: "Cambodia",
    MM: "Myanmar (Burma)",
    LA: "Laos",
    BN: "Brunei",
    TL: "Timor-Leste",
    NZ: "New Zealand",
    NG: "Nigeria",
    EG: "Egypt",
    ZA: "South Africa",
    KE: "Kenya",
    GH: "Ghana",
    ET: "Ethiopia",
    MA: "Morocco",
    DZ: "Algeria",
    TZ: "Tanzania",
    UG: "Uganda",
    SN: "Senegal",
    CI: "Ivory Coast",
    CD: "Democratic Republic of Congo",
    TN: "Tunisia",
    SD: "Sudan",
    RW: "Rwanda",
    ZM: "Zambia",
    BW: "Botswana",
    NA: "Namibia",
    ZW: "Zimbabwe",
    LY: "Libya",
    MZ: "Mozambique",
    MW: "Malawi",
    ML: "Mali",
    SL: "Sierra Leone",
    TG: "Togo",
    BJ: "Benin",
    BF: "Burkina Faso",
    MR: "Mauritania",
    NE: "Niger",
    LR: "Liberia",
    GM: "Gambia",
    GQ: "Equatorial Guinea",
    GA: "Gabon",
    CF: "Central African Republic",
    TD: "Chad",
    ER: "Eritrea",
    SO: "Somalia",
    SS: "South Sudan",
    LS: "Lesotho",
    SZ: "Swaziland (Eswatini)",
    CV: "Cape Verde",
    ST: "São Tomé and Príncipe",
    SC: "Seychelles",
    KM: "Comoros",
    DJ: "Djibouti",
    BR: "Brazil",
    AR: "Argentina",
    CL: "Chile",
    CO: "Colombia",
    PE: "Peru",
    VE: "Venezuela",
    UY: "Uruguay",
    PY: "Paraguay",
    EC: "Ecuador",
    BO: "Bolivia",
    GY: "Guyana",
    SR: "Suriname",
    GF: "French Guiana (France)"
  };
   const regions = {
      "North America": [
        "United States", "Canada", "Mexico", "Bermuda", "Greenland", "Saint Pierre and Miquelon"
      ],
      "Western Europe": [
        "United Kingdom", "Ireland", "France", "Germany", "Belgium", "Netherlands", "Luxembourg",
        "Switzerland", "Austria", "Monaco", "Liechtenstein", "Andorra"
      ],
      "Eastern Europe": [
        "Poland", "Romania", "Hungary", "Czech Republic", "Slovakia", "Bulgaria", "Moldova",
        "Ukraine", "Belarus", "Russia (western part)", "Albania", "Serbia", "North Macedonia",
        "Montenegro", "Bosnia and Herzegovina", "Kosovo"
      ],
      "Middle East": [
        "United Arab Emirates", "Saudi Arabia", "Qatar", "Bahrain", "Kuwait", "Oman", "Jordan",
        "Lebanon", "Israel", "Palestine", "Iraq", "Syria", "Yemen", "Iran"
      ],
      "South Asia": [
        "India", "Pakistan", "Bangladesh", "Sri Lanka", "Nepal", "Bhutan", "Maldives", "Afghanistan"
      ],
      "East Asia": [
        "China", "Japan", "South Korea", "North Korea", "Taiwan", "Mongolia", "Hong Kong", "Macau"
      ],
      "Southeast Asia": [
        "Singapore", "Philippines", "Thailand", "Malaysia", "Indonesia", "Vietnam", "Cambodia",
        "Myanmar (Burma)", "Laos", "Brunei", "Timor-Leste"
      ],
      "Australia & New Zealand": [
        "Australia", "New Zealand"
      ],
      "Africa": [
        "Nigeria", "South Africa", "Egypt", "Kenya", "Ghana", "Ethiopia", "Morocco", "Algeria",
        "Tanzania", "Uganda", "Senegal", "Ivory Coast", "Democratic Republic of Congo", "Tunisia",
        "Sudan", "Rwanda", "Zambia", "Botswana", "Namibia", "Zimbabwe", "Libya", "Mozambique",
        "Malawi", "Mali", "Sierra Leone", "Togo", "Benin", "Burkina Faso", "Mauritania", "Niger",
        "Liberia", "Gambia", "Equatorial Guinea", "Gabon", "Central African Republic", "Chad",
        "Eritrea", "Somalia", "South Sudan", "Lesotho", "Swaziland (Eswatini)", "Cape Verde",
        "São Tomé and Príncipe", "Seychelles", "Comoros", "Djibouti"
      ],
      "South America": [
        "Brazil", "Argentina", "Chile", "Colombia", "Peru", "Venezuela", "Uruguay", "Paraguay",
        "Ecuador", "Bolivia", "Guyana", "Suriname", "French Guiana (France)"
      ]
    };

const popup = document.getElementById("country-popup");
const toggleButton = document.getElementById("change-country-toggle");
const cancelButton = document.querySelector(".chnage-cancel");
const updateButton = document.querySelector(".change-update");
const select = popup.querySelector("select");
const regionSelect = document.getElementById("region");
const countrySelect = document.getElementById("country");
const countryNameSpan = document.getElementById("country-name");


document.addEventListener("click", function (event) {
  if (event.target.classList.contains("change-update")) {
    const selectedCountry = countrySelect.value;

    if (selectedCountry) {
      countryNameSpan.textContent = selectedCountry;
      document.getElementById("country-popup").style.display = "none";
      updateShippingEstimate(selectedCountry);
    } else {
      alert("Please select a country.");
    }
  }
});


regionSelect.addEventListener('change', function () {
  const selectedRegion = this.value;
  const countries = regions[selectedRegion] || [];

  countrySelect.innerHTML = '';
 
  const defaultOption = document.createElement('option');
  defaultOption.value = '';
  defaultOption.textContent = '-- Select Country --';
  countrySelect.appendChild(defaultOption);

  countries.forEach(function (country) {
    const option = document.createElement('option');
    option.value = country;
    option.textContent = country;
    countrySelect.appendChild(option);
  });
});


  try {
    const response = await fetch("https://api.country.is");
    const data = await response.json();
    const countryCode = data.country;
    const fullName = countryCodeToName[countryCode] || countryCode;
    countryNameSpan.textContent = fullName;
       if (select) {
      let found = false;
      for (let i = 0; i < select.options.length; i++) {
        if (select.options[i].value === fullName) {
          select.value = fullName;
          found = true;
          break;
        }
      }

      if (!found && regionSelect && typeof regions !== "undefined") {
        for (const region in regions) {
          if (regions[region].includes(fullName)) {
            regionSelect.value = region;
            const event = new Event("change");
            regionSelect.dispatchEvent(event);

            for (let i = 0; i < countrySelect.options.length; i++) {
              if (countrySelect.options[i].value === fullName) {
                countrySelect.value = fullName;
                break;
              }
            }

            break;
          }
        }
      }
    }

    updateShippingEstimate(fullName);
  } catch (err) {
    countryNameSpan.textContent = "Unknown";
    updateShippingEstimate("Unknown");
  }
}


 function updateShippingEstimate(country) {
  const shippingEstimates = {
  "United States": document.getElementById("us-shipping-estimate"),
  "Canada": document.getElementById("us-shipping-estimate"),
  "Greenland": document.getElementById("us-shipping-estimate"),
  "Bermuda": document.getElementById("us-shipping-estimate"),
  "Mexico": document.getElementById("us-shipping-estimate"),
  "Saint Pierre and Miquelon": document.getElementById("us-shipping-estimate"),
  "United Kingdom": document.getElementById("uk-shipping-estimate"),
  "Ireland": document.getElementById("uk-shipping-estimate"),
  "Germany": document.getElementById("uk-shipping-estimate"),
  "France": document.getElementById("uk-shipping-estimate"),
  "Belgium": document.getElementById("uk-shipping-estimate"),
  "Monaco": document.getElementById("uk-shipping-estimate"),
  "Netherlands": document.getElementById("uk-shipping-estimate"),
  "Luxembourg": document.getElementById("uk-shipping-estimate"),
  "Switzerland": document.getElementById("uk-shipping-estimate"),
  "Liechtenstein": document.getElementById("uk-shipping-estimate"),
  "Andorra": document.getElementById("uk-shipping-estimate"),
  "Austria": document.getElementById("uk-shipping-estimate"),
  "United Arab Emirates": document.getElementById("uk-shipping-estimate"),
  "Saudi Arabia": document.getElementById("uk-shipping-estimate"),
  "Qatar": document.getElementById("uk-shipping-estimate"),
  "Bahrain": document.getElementById("uk-shipping-estimate"),
  "Kuwait": document.getElementById("uk-shipping-estimate"),
  "Oman": document.getElementById("uk-shipping-estimate"),
  "Jordan": document.getElementById("uk-shipping-estimate"),
  "Lebanon": document.getElementById("uk-shipping-estimate"),
  "Israel": document.getElementById("uk-shipping-estimate"),
  "Iraq": document.getElementById("uk-shipping-estimate"),
  "Palestine": document.getElementById("uk-shipping-estimate"),
  "Syria": document.getElementById("uk-shipping-estimate"),
  "Yemen": document.getElementById("uk-shipping-estimate"),
  "Iran": document.getElementById("uk-shipping-estimate"),
  "Australia": document.getElementById("uk-shipping-estimate"),
  "New Zealand": document.getElementById("uk-shipping-estimate"),
  "India": document.getElementById("in-shipping-estimate"),
  "Sri Lanka": document.getElementById("in-shipping-estimate"),
  "Bangladesh": document.getElementById("in-shipping-estimate"),
  "Pakistan": document.getElementById("in-shipping-estimate"),
  "Nepal": document.getElementById("in-shipping-estimate"),
  "Bhutan": document.getElementById("in-shipping-estimate"),
  "Maldives": document.getElementById("in-shipping-estimate"),
  "Afghanistan": document.getElementById("in-shipping-estimate"),
  "Poland": document.getElementById("po-shipping-estimate"),
  "Romania": document.getElementById("po-shipping-estimate"),
  "Hungary": document.getElementById("po-shipping-estimate"),
  "Czech Republic": document.getElementById("po-shipping-estimate"),
  "Slovakia": document.getElementById("po-shipping-estimate"),
  "Bulgaria": document.getElementById("po-shipping-estimate"),
  "Moldova": document.getElementById("po-shipping-estimate"),
  "Ukraine": document.getElementById("po-shipping-estimate"),
  "Belarus": document.getElementById("po-shipping-estimate"),
  "Russia": document.getElementById("po-shipping-estimate"),
  "Albania": document.getElementById("po-shipping-estimate"),
  "Serbia": document.getElementById("po-shipping-estimate"),
  "North Macedonia": document.getElementById("po-shipping-estimate"),
  "Montenegro": document.getElementById("po-shipping-estimate"),
  "Bosnia and Herzegovina": document.getElementById("po-shipping-estimate"),
  "Kosovo": document.getElementById("po-shipping-estimate"),
  "Japan": document.getElementById("es-shipping-estimate"),
  "South Korea": document.getElementById("es-shipping-estimate"),
  "China": document.getElementById("es-shipping-estimate"),
  "North Korea": document.getElementById("es-shipping-estimate"),
  "Taiwan": document.getElementById("es-shipping-estimate"),
  "Mongolia": document.getElementById("es-shipping-estimate"),
  "Hong Kong": document.getElementById("es-shipping-estimate"),
  "Macau": document.getElementById("es-shipping-estimate"),
  "Philippines": document.getElementById("sa-shipping-estimate"),
  "Singapore": document.getElementById("sa-shipping-estimate"),
  "Thailand": document.getElementById("sa-shipping-estimate"),
  "Indonesia": document.getElementById("sa-shipping-estimate"),
  "Malaysia": document.getElementById("sa-shipping-estimate"),
  "Vietnam": document.getElementById("sa-shipping-estimate"),
  "Cambodia": document.getElementById("sa-shipping-estimate"),
  "Myanmar (Burma)": document.getElementById("sa-shipping-estimate"),
  "Laos": document.getElementById("sa-shipping-estimate"),
  "Brunei": document.getElementById("sa-shipping-estimate"),
  "Timor-Leste": document.getElementById("sa-shipping-estimate"),
  "Nigeria": document.getElementById("a-shipping-estimate"),
  "Egypt": document.getElementById("a-shipping-estimate"),
  "South Africa": document.getElementById("a-shipping-estimate"),
  "Kenya": document.getElementById("a-shipping-estimate"),
  "Ghana": document.getElementById("a-shipping-estimate"),
  "Ethiopia": document.getElementById("a-shipping-estimate"),
  "Morocco": document.getElementById("a-shipping-estimate"),
  "Algeria": document.getElementById("a-shipping-estimate"),
  "Tanzania": document.getElementById("a-shipping-estimate"),
  "Uganda": document.getElementById("a-shipping-estimate"),
  "Senegal": document.getElementById("a-shipping-estimate"),
  "Ivory Coast": document.getElementById("a-shipping-estimate"),
  "Democratic Republic of Congo": document.getElementById("a-shipping-estimate"),
  "Tunisia": document.getElementById("a-shipping-estimate"),
  "Sudan": document.getElementById("a-shipping-estimate"),
  "Rwanda": document.getElementById("a-shipping-estimate"),
  "Zambia": document.getElementById("a-shipping-estimate"),
  "Botswana": document.getElementById("a-shipping-estimate"),
  "Namibia": document.getElementById("a-shipping-estimate"),
  "Zimbabwe": document.getElementById("a-shipping-estimate"),
  "Libya": document.getElementById("a-shipping-estimate"),
  "Mozambique": document.getElementById("a-shipping-estimate"),
  "Malawi": document.getElementById("a-shipping-estimate"),
  "Mali": document.getElementById("a-shipping-estimate"),
  "Sierra Leone": document.getElementById("a-shipping-estimate"),
  "Togo": document.getElementById("a-shipping-estimate"),
  "Benin": document.getElementById("a-shipping-estimate"),
  "Burkina Faso": document.getElementById("a-shipping-estimate"),
  "Mauritania": document.getElementById("a-shipping-estimate"),
  "Niger": document.getElementById("a-shipping-estimate"),
  "Liberia": document.getElementById("a-shipping-estimate"),
  "Gambia": document.getElementById("a-shipping-estimate"),
  "Equatorial Guinea": document.getElementById("a-shipping-estimate"),
  "Gabon": document.getElementById("a-shipping-estimate"),
  "Central African Republic": document.getElementById("a-shipping-estimate"),
  "Chad": document.getElementById("a-shipping-estimate"),
  "Eritrea": document.getElementById("a-shipping-estimate"),
  "Somalia": document.getElementById("a-shipping-estimate"),
  "South Sudan": document.getElementById("a-shipping-estimate"),
  "Lesotho": document.getElementById("a-shipping-estimate"),
  "Swaziland (Eswatini)": document.getElementById("a-shipping-estimate"),
  "Cape Verde": document.getElementById("a-shipping-estimate"),
  "São Tomé and Príncipe": document.getElementById("a-shipping-estimate"),
  "Seychelles": document.getElementById("a-shipping-estimate"),
  "Comoros": document.getElementById("a-shipping-estimate"),
  "Djibouti": document.getElementById("a-shipping-estimate"),
  "Brazil": document.getElementById("sm-shipping-estimate"),
  "Argentina": document.getElementById("sm-shipping-estimate"),
  "Chile": document.getElementById("sm-shipping-estimate"),
  "Colombia": document.getElementById("sm-shipping-estimate"),
  "Peru": document.getElementById("sm-shipping-estimate"),
  "Venezuela": document.getElementById("sm-shipping-estimate"),
  "Uruguay": document.getElementById("sm-shipping-estimate"),
  "Paraguay": document.getElementById("sm-shipping-estimate"),
  "Ecuador": document.getElementById("sm-shipping-estimate"),
  "Bolivia": document.getElementById("sm-shipping-estimate"),
  "Guyana": document.getElementById("sm-shipping-estimate"),
  "Suriname": document.getElementById("sm-shipping-estimate"),
  "French Guiana (France)": document.getElementById("sm-shipping-estimate")
}
  
  for (const estimate of Object.values(shippingEstimates)) {
    estimate.style.display = "none";
  }
  document.getElementById("default-shipping-estimate").style.display = "none";
   if (shippingEstimates[country]) {
       shippingEstimates[country].style.display = "block";
  } else {
      document.getElementById("default-shipping-estimate").style.display = "block";
  }
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){
			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {
					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);
                    setCountry();            

				})
				.catch(e => {
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
                   
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}
		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}


$( document ).ready(function() {
  setCountry();
});
